import { TabView, TabPanel } from 'primereact/tabview';

export default function ServiceCarbonFootprintIndex() {
    return (
        <>
        <div className="p-card bg-gray">
                <div className="p-card-body">
                    <span>昕力資訊</span>
                </div>
            </div>

            <div className="p-card">
                <div className="p-card-body">
                    <TabView>
                        <TabPanel header="基本資料">

                        </TabPanel>
                        <TabPanel header="原料取得階段">
                            
                        </TabPanel>
                        <TabPanel header="服務階段">
                            
                        </TabPanel>
                        <TabPanel header="配銷(運輸)階段">
                            
                        </TabPanel>
                        <TabPanel header="使用階段">
                           
                        </TabPanel>
                        <TabPanel header="廢棄階段">
                            
                        </TabPanel>
                    </TabView>
                </div>
            </div>
        </>
)}